export const fetchProductReviewSummaries = async (productIds: string[]) => {
  const params = new URLSearchParams();
  for (const id of productIds) {
    params.append('product_ids[]', id);
  }

  return fetch(`/product_review_summaries?${params.toString()}`, {
    method: 'GET',
    headers: {
      'Sec-Fetch-Dest': 'empty',
    },
  });
};
